import React, { useState } from "react";
import WagonYearWiseChart from "./WagonYearWiseChart";

import WagonTargetPercentageData from "./WagonTargetPercentageData";
import CircularGaugeChart from "../../../CHARTS/CircularGaugeChart";
import GroupedBarChart from "../../../CHARTS/GroupedBarChart";
import WagonSidingWise from "./WagonSidingWise";
import SunBurst from "./SunBurst";
import SummeryData from "./SummeryData";
import TotalBar from "./TotalBar";
import WagonYearWiseChartUpdated from "./WagonYearWiseChartUpdated";
import SevenAMonthwiseReport from "./SevenAMonthwiseReport";
import TotalBarTow from "./TotalBarTwo";
import NoDataFound from "../../../Extra/NoDataFound";
const Wagon = ({ data, status }) => {
  const [chartData, setChartData] = useState(null);
  const [yearData, setyearData] = useState([]);
  const [summery, setSummery] = useState(null);
  const [targetData, setTargetData] = useState([]);
  const [twoCommodityTargetAchieved, setTwoCommodityTargetAchieved] =
    useState(null);
  return (
    <div className="fade-in-up">
      {" "}
      <h5>7A Loading (WAGON) </h5>
      <hr className="m-1 " />
      <div>
        <WagonTargetPercentageData
          chartData={chartData}
          setTwoCommodityTargetAchieved={setTwoCommodityTargetAchieved}
          yearData={yearData}
          setyearData={setyearData}
        />
      </div>
      <div className="row  d-flex justify-content-center">
        <div className="col-md-8  ">
          <div className="newUiBody">
            {chartData?.series?.length <= 0 ? (
              <b style={{ color: "red" }}>No Data Found !</b>
            ) : null}
            <WagonYearWiseChartUpdated
              //  <WagonYearWiseChart
              chartData={chartData}
              setTargetData={setTargetData}
              targetData={targetData}
              setSummery={setSummery}
              setChartData={setChartData}
              data={data}
            />
          </div>
          {console.log("targetData", targetData)}
        </div>
        <div className="col-md-4  ">
          <div className="newUiBody">
            {data?.length > 0 ? (
              <TotalBar
                status={status}
                targetData={targetData}
                chartData={chartData}
                from={"Wagon"}
                // targetData={targetData}
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        {summery?.commodityWise && (
          <div className="col-md-12">
            <div className="newUiBody">
              <SevenAMonthwiseReport
                status={status}
                targetData={targetData}
                from={"wagon"}
                data={summery.commodityWise}
              />
            </div>
          </div>
        )}
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-md-8  ">
          <div className="newUiBody">
            {chartData?.series?.length <= 0 ? (
              <b style={{ color: "red" }}>No Data Found !</b>
            ) : null}
            <WagonSidingWise
              chartData={chartData}
              setChartData={setChartData}
              data={data}
            />
          </div>
        </div>
        <div className="col-md-4  ">
          <div className="newUiBody">
            {data?.length > 0 ? (
              <SunBurst data={[data[0]]} keyName={"WAGON"} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Wagon;
